export class WebSocketEmitter {

    constructor(gudhub) {
        this.gudhub = gudhub;
    }

    async emitToUser(user_id, data) {

        const message = {
            user_id,
            data: typeof data === 'object' ? JSON.stringify(data) : data
        }

        const response = await this.gudhub.req.post({
            url: '/ws/emit-to-user',
            form: message
        });

        return response;

    }

    async broadcastToAppSubscribers(app_id, data_type, data) {
        
        const message = {
            app_id,
            data: JSON.stringify({
                data_type,
                data
            })
        }

        const response = await this.gudhub.req.post({
            url: '/ws/broadcast-to-app-subscribers',
            form: message
        });

        return response;

    }

}